export default __webpack_public_path__ + "static/bodySectionBg-63816a40bf79bf457071ee57b155edb3.png";